<div>
  <img src="data:image/png;base64,{{base64}}" alt="Firma" height="300"
    style="max-width: 500px !important; object-fit: contain;">
</div>